import { subDays, subMonths, format, isDate, parse } from 'date-fns'

export function oneWeekAgoRange() {
    const now = new Date()

    return {
        since: subDays(now, 7),
        until: now
    }
}

export function oneMonthAgoRange() {
    const now = new Date()

    return {
        since: subMonths(now, 1),
        until: now
    }
}

export function todayRange() {
    const now = new Date()

    return {
        since: now,
        until: now
    }
}

export function twoMonthsAgo() {
    return subMonths(new Date(), 2)
}

export function fourMonthsAgo() {
    return subMonths(new Date(), 4)
}

class DateCacheService {
    forget(key) {
        window.localStorage.removeItem(key)
    }

    set(key, value = null) {
        if (value === null || typeof value === 'undefined') {
            return window.localStorage.removeItem(key)
        }

        return window.localStorage.setItem(key, JSON.stringify(value))
    }

    setAlias(key, alias = null) {
        if (alias === null || typeof alias === 'undefined') {
            return window.localStorage.removeItem(key)
        }

        return window.localStorage.setItem(key, JSON.stringify({ alias }))
    }

    get(key, fallback = null) {
        const value = window.localStorage.getItem(key)

        if (value) {
            const range = JSON.parse(value)

            if (range.alias) {
                switch (range.alias) {
                    case 'today':
                        return todayRange()
                    case 'oneWeekAgo':
                        return oneWeekAgoRange()
                    case 'oneMonthAgo':
                        return oneMonthAgoRange()
                }
            } else {
                return range
            }
        }

        if (typeof fallback === 'function') {
            return fallback()
        }

        return null
    }

    getFormatted(key, fallback = null, f = 'YYYY-MM-DD') {
        const value = this.get(key, fallback)

        if (!value) {
            return null
        }

        if (isDate(value)) {
            return format(value, f)
        }

        const { since, until } = value

        return {
            since: isDate(since) ? format(since, f) : since,
            until: isDate(until) ? format(until, f) : until
        }
    }

    /**
     * Вернет false, если дата старше 4 месяцев
     */
    isTooFar(someDate) {
        try {
            if (!isDate(someDate)) {
                someDate = parse(someDate)
            }

            return someDate.setHours(0, 0, 0, 0).valueOf() < fourMonthsAgo().setHours(0, 0, 0, 0).valueOf()
        } catch (e) {
            return false
        }
    }
}

export default new DateCacheService()
